// eslint-disable-next-line import/prefer-default-export
export const hasEditUsersPermission = (permissions: IPermissionType[]) => permissions.some((permission: IPermissionType) => permission.name === 'Write Users')
